<template>
    <div class="in-app-preview-layout">
        <div class="in-app-preview-layout-vertical">
            <slot name="vertical"></slot>
        </div>
<!--        <div class="in-app-preview-layout-horizontal">-->
<!--            <slot name="horizontal"></slot>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    name: "in-app-preview-layout",
};
</script>

<style lang="scss">
$bgBaseSize: 50vh;
@media(max-height: 1500px){
    $bgBaseSize: 44vh;
}

@function bgSecondSize(){
    @return $bgBaseSize * 0.5086
}

.in-app-preview-layout {
    height: 65vh;

    &-vertical {
        height: $bgBaseSize;
        width: bgSecondSize();
        background-image: url('~@/assets/images/inApp/previewBg.svg');
        background-position: center;
        background-size: cover;
        position: relative;
    }

    &-horizontal {
        width: $bgBaseSize;
        height: bgSecondSize();
        background-image: url('~@/assets/images/inApp/previewBgHorizontal.svg');
        background-position: center;
        background-size: cover;
        position: relative;
        top: -15vh;
        overflow: hidden;
    }
}
</style>
